import { Localized } from "../strings";

export const isRequiredValidation = (value?: string): string | undefined => {
  const strings = Localized.object("VALIDATION");
  if (value?.length) return;
  return strings.MANDATORY_FIELD;
};
